import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'postcode', 'list', 'results',
    'line1', 'line2', 'line3', 'line4',
    'city', 'county', 'country',
    'postcodeError', 'searchError', 'noResults'
  ]
  static values  = { url: String }

  connect() {
    this.refreshBoundActions = this.refreshBoundActions.bind(this)
    document.addEventListener("turbo:frame-load", this.refreshBoundActions)
  }

  disconnect() {
    document.removeEventListener("turbo:frame-load", this.refreshBoundActions)
  }

  refreshBoundActions(event) {
    const frame = event.target
    if (this.element.contains(frame)) {
      this.application.load()
    }
  }

  search (e) {
    e.preventDefault()

    if (!this.postcodeTarget.value.length) {
      this.postcodeErrorTarget.classList.remove('hidden')
    }
    else {
      this.postcodeErrorTarget.classList.add('hidden')
      if (this.hasSearchErrorTarget) this.searchErrorTarget.classList.add('hidden')
      if (this.hasNoResultsTarget) this.noResultsTarget.classList.add('hidden')
      if (this.hasResultsTarget) this.resultsTarget.classList.add('hidden')

      this.postcodeTarget.value = this.postcodeTarget.value.toUpperCase()

      const params = new URLSearchParams({
        postcode: this.postcodeTarget.value,
        expand: "true"
      })

      this.loadJson(`${this.urlValue}?${params}`, this.processAddresses.bind(this))
    }
  }

  select (e) {
    const option = e?.currentTarget?.value
    if (!option) return

    this.property = JSON.parse(option)
  }

  set property(property) {
    this.line1Target.value = property.line_1
    this.line2Target.value = property.line_2
    this.line3Target.value = property.line_3
    this.line4Target.value = property.line_4
    this.cityTarget.value = property.town_or_city
    this.countyTarget.value = property.county

    if (this.hasCountryTarget) {
      this._setCountry(property.country)
    }
  }

  _setCountry(country) {
    const countrySelect = this.countryTarget
    const controller = this.application.getControllerForElementAndIdentifier(countrySelect.parentElement, "single-select-field")

    if (controller) {
      controller.setValue(country)
    }
  }

  processAddresses(data) {
    if (data.error) {
      if (this.hasSearchErrorTarget) this.searchErrorTarget.classList.remove('hidden')
      return
    }

    const result = Array.isArray(data.addresses) && data.addresses.length > 0
      ? data.addresses.map(item => ({
        id: JSON.stringify(item),
        name: (item.formatted_address || [])
          .filter(part => typeof part === 'string' && part.trim() !== '')
          .join(", ")
      }))
      : []

    if (result.length === 0) {
      if (this.hasNoResultsTarget) this.noResultsTarget.classList.remove('hidden')
      return
    }

    if (this.hasResultsTarget) this.resultsTarget.classList.remove('hidden')

    requestAnimationFrame(() => {
      const controller = this.application.getControllerForElementAndIdentifier(
        this.listTarget.closest(`div[data-controller="single-select-field-component-with-search"]`),
        'single-select-field-component-with-search'
      )
      if (controller) {
        controller.refreshOptions(result)
      }
    })
  }

  async loadJson(url, callback) {
    try {
      const response = await fetch(url)
      const data = await response.json()

      callback(data)
    } catch (error) {
      console.error("Fetch error:", error)
      if (this.hasSearchErrorTarget) this.searchErrorTarget.classList.remove('hidden')
    }
  }
}
